import jMoment from "moment-jalaali";
import React, { useEffect, useState } from "react";
import { MobileDatePicker } from "@mui/x-date-pickers";
import { digitsFaToEn } from "@persian-tools/persian-tools";

const DateWidget = (props) => {
  const { value, schema, onChange, disabled, readonly } = props;
  const [date, setDate] = useState(null);
  const [flag, setFlag] = useState(true);

  const formattedDate = (x) => digitsFaToEn(jMoment(x).format("YYYY-MM-DD"));

  const onAccept = (date) => {
    setFlag(false);
    setDate(formattedDate(date));
    onChange(formattedDate(date));
  };

  useEffect(() => {
    if (flag && value) {
      return onAccept(value);
    }
  }, [value]);

  return (
    <MobileDatePicker
      closeOnSelect
      onAccept={onAccept}
      label={schema.title}
      sx={{ direction: "rtl" }}
      value={date && jMoment(date)}
      disabled={disabled || readonly}
      slotProps={{
        toolbar: { toolbarFormat: "ddd DD jMMMM jYYYY", hidden: false },
        desktopPaper: {
          dir: "rtl",
        },
        mobilePaper: {
          dir: "rtl",
        },
      }}
    />
  );
};

export default DateWidget;
